import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { allowedExtensions, validExtensionTypes } from 'shared/utils';

import { ReactComponent as DragDropIcon } from 'assets/icon-drag-drop.svg';
import { ReactComponent as SearchIcon } from 'assets/icon-search.svg';

import { BoxAttachDocument } from './styles';

const DragDrop = ({ className, onChangeFile, onError, height, iconWidth }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();
  const [isDrop, setIsDrop] = useState(false);

  const callOnChangeFile = (files) => {
    const validTypes = validExtensionTypes;
    const existFiles = files.map((file) => {
      const existExtensions = validTypes.some(
        (x) => file.name.toUpperCase().endsWith(x) || file.name.toLowerCase().endsWith(x)
      );
      if (!existExtensions) {
        onError(t('general_invalid_file_type'));
        const newFile = file;
        newFile.isValidFile = false;
        return newFile;
      }
      onError('');
      const newFile = file;
      newFile.isValidFile = true;
      return newFile;
    });
    onChangeFile(existFiles.filter((x) => x.isValidFile));
  };

  const onClickUploadSection = () => {
    fileInputRef?.current?.click();
  };

  const dragOver = (e) => {
    setIsDrop(true);
    e.preventDefault();
  };

  const dragEnter = (e) => {
    setIsDrop(true);
    e.preventDefault();
  };

  const dragLeave = (e) => {
    setIsDrop(false);
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.preventDefault();
    const { files } = e.dataTransfer;
    const newFiles = [...files];
    setIsDrop(false);
    callOnChangeFile(newFiles);
  };

  const fileSelected = (e) => {
    if (fileInputRef.current.files.length) {
      const { files } = fileInputRef.current;
      const newFiles = [...files];
      callOnChangeFile(newFiles);
      e.target.value = '';
    }
  };

  return (
    <>
      <div className={classNames(['image-uploader', { className }])}>
        <BoxAttachDocument
          onClick={onClickUploadSection}
          aria-hidden="true"
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          onDrop={fileDrop}
          className="d-flex justify-content-center flex-column p-3"
          isDrop={isDrop}
          height={height}
        >
          <div className="d-flex flex-column m-2 pt-1">
            <div className="d-flex justify-content-center mb-4">
              <DragDropIcon width={iconWidth} />
            </div>
            <span className="text-center drag-drop-notification-drag">
              {t('notification_drag')}
            </span>
          </div>
          <div className="text-center explore_computer-container">
            <hr />
            <span>{t('notification_explore_computer')}</span>
            <SearchIcon width="17" className="ml-1" />
          </div>
        </BoxAttachDocument>
        <input
          ref={fileInputRef}
          type="file"
          onChange={fileSelected}
          multiple
          accept={allowedExtensions}
        />
      </div>
    </>
  );
};

DragDrop.defaultProps = {
  className: '',
  onError: (error) => error,
  height: 280,
  iconWidth: 45,
};

DragDrop.propTypes = {
  className: PropTypes.string,
  onChangeFile: PropTypes.func.isRequired,
  onError: PropTypes.func,
  height: PropTypes.number,
  iconWidth: PropTypes.number,
};

export default DragDrop;
